/**
 * How a search row that stands for a Live run or session reads and where it
 * opens. The server folds a run's captures into one row (`group`); these
 * helpers are the one place the palette and the phone search turn that into
 * words and a route, so the two surfaces say the same thing.
 */
import { ROUTES } from '../constants/routes';
import type { SearchResult } from '../services/search.service';

/** "Run 3 · PCR", or a generic name when the protocol is not readable. */
export function searchGroupContext(result: Pick<SearchResult, 'group'>): string | undefined {
  const { group } = result;
  if (!group) return undefined;
  return group.label ?? (group.kind === 'run' ? 'Protocol run' : 'Live session');
}

/** How many more captures of the same run this search found. */
export function searchGroupMore(result: Pick<SearchResult, 'group'>): number {
  return Math.max((result.group?.count ?? 1) - 1, 0);
}

/** The run page, when the row stands for a run whose protocol the caller can read. */
export function searchGroupRoute(result: Pick<SearchResult, 'group'>): string | undefined {
  const { group } = result;
  if (group?.kind !== 'run' || !group.protocolId) return undefined;
  return ROUTES.protocolRun(group.protocolId, group.id);
}
